<div class="dialog-container">
    <h1 mat-dialog-title class="title">
        {{ 'aumico_users_organization_change_organization_state_modal_title' | i18next }}
    </h1>

    <div class="container">
        <aum-select
            placeholder="{{ 'aumico_annual_report_import_please_select' | i18next }}"
            [options]="organizationStatusOptions"
            [aumFormControl]="stateFormControl"
        >
        </aum-select>

        <div class="action-wrapper">
            <button (click)="closeDialog()">
                {{ 'aumico_users_organization_change_organization_state_modal_confirm_no_action' | i18next }}
            </button>
            <button class="confirmation-action" (click)="onAction()" [disabled]="stateFormControl.invalid">
                {{ 'aumico_users_organization_change_organization_state_modal_confirm_action' | i18next }}
            </button>
        </div>
    </div>
</div>
